const ACRONYMS = new Set(['id', 'url', 'api']);

export function prettifyConfigKey(configKey: string): string {
  return configKey
    .split(/(?=[A-Z])/)
    .map((s) =>
      ACRONYMS.has(s.toLowerCase()) ? s.toUpperCase() : s.replace(/^./, (c) => c.toUpperCase())
    )
    .join(' ');
}
